<mat-spinner *ngIf="loading" style="margin:0 auto;"></mat-spinner>

<div *ngIf="!loading" fxLayout="column" fxLayoutGap="2rem">

    <div *ngIf="breadcrumb.length != 0" fxLayout="row" fxLayoutGap="0.5rem" class="breadcrumb">
        <ng-container *ngFor="let b of breadcrumb; let i = index;">
            <div>
                <a [routerLink]="['/home', b.id]" *ngIf="b.link">{{b.label}}</a>
                <span *ngIf="!b.link">{{b.label}}</span>
            </div>
            <div>
                <span *ngIf="i != breadcrumb.length - 1">|</span>
            </div>
        </ng-container>
    </div>

    <div *ngIf="currentUser.isPresenter">
        <h1 fxLayoutAlign="space-between" style="margin:0">
            <span>{{levelName[1]}}</span>
            <button mat-flat-button color="primary" (click)="addNode()" *ngIf="!loading">
                <mat-icon>add</mat-icon> Add {{levelName[0]}}
            </button>
        </h1>
    </div>

    <div [ngStyle]="{'opacity': loadingNavigationNodes ? '0.5' : '1'}" style="position: relative;" *ngIf="currentUser.isPresenter">
        <div *ngIf="navigationNodes.length != 0">
            <div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="1rem" *ngIf="navigationNodes.length != 0" [sortablejs]="navigationNodes" [sortablejsOptions]="nodeSortablejsOptions">
                <div *ngFor="let navigationNode of navigationNodes" style="position: relative;">
                    <ng-container *ngTemplateOutlet="nodeCard; context: { node: navigationNode }"></ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="navigationNodes == undefined || navigationNodes.length == 0">
            <h3 style="margin:0">
                No {{levelName[1]}}
            </h3>
        </div>

        <div style="position: absolute; top:0; bottom:0; left:0; right:0;" *ngIf="loadingNavigationNodes">
        </div>

    </div>

    <ng-container *ngIf="navigationNodeId != null && currentUser.isPresenter">

        <h1 fxLayoutAlign="space-between" style="margin: 0">
            <span>Modules</span>
            <button mat-flat-button color="primary" (click)="addModule()" *ngIf="!loading">
                <mat-icon>add</mat-icon> Add Module
            </button>
        </h1>

        <div [ngStyle]="{'opacity': loadingModules ? '0.5' : '1'}" style="position: relative;">

            <div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="1rem" [sortablejs]="modules" [sortablejsOptions]="moduleSortablejsOptions" *ngIf="modules != undefined && modules.length != 0">
                <div *ngFor="let module of modules">
                    <ng-container *ngTemplateOutlet="moduleCard; context: { module: module }"></ng-container>
                </div>
            </div>

            <h3 style="margin:0" *ngIf="modules == undefined || modules.length == 0">
                No Modules
            </h3>

            <div style="position: absolute; top:0; bottom:0; left:0; right:0;" *ngIf="loadingModules">
            </div>

        </div>

    </ng-container>

    <ng-container *ngIf="!currentUser.isPresenter">
        <div gdColumns="repeat(auto-fill, minmax(250px, 1fr))" gdGap="1rem">
            <div *ngFor="let navigationNode of navigationNodes" style="position: relative;">
                <ng-container *ngTemplateOutlet="nodeCard; context: { node: navigationNode }"></ng-container>
            </div>
            <div *ngFor="let module of modules" style="position: relative;">
                <ng-container *ngTemplateOutlet="moduleCard; context: { module: module }"></ng-container>
            </div>
            <div *ngIf="navigationNodes.length == 0 && modules.length == 0">
                <h3 style="margin:0">
                    No Content
                </h3>
            </div>
        </div>
    </ng-container>

</div>

<ng-template #nodeCard let-node="node">
    <div class="node-card">
        <div style="position: absolute; width:96%; height:96%; ">
            <mat-card style="height:100%; padding-bottom: 0;"></mat-card>
        </div>
        <div style="position: absolute; width:96%; height:94%; top: 4%; left: 2%;">
            <mat-card style="height:100%; padding-bottom: 0;"></mat-card>
        </div>
        <div fxFlex style="margin-top:4%; margin-left: 4%;">
            <mat-card style="height:100%" fxLayout="column" fxFlex style="cursor: pointer;" (click)="handleNavigationNodeClick(node.id)">
                <mat-card-content fxFlex="grow" fxLayout="column">
                    <div style="height:200px;background-position: top center; background-size: cover;" [ngStyle]="{backgroundImage: 'url(' + node.image + ')'}" *ngIf="node.image" fxFlex="noshrink">
                    </div>
                    <div style="margin: 16px; margin-bottom: 0;" fxLayout="row" fxLayoutAlign="start center" fxFlex="grow">
                        <div fxFlex="grow">
                            <p style="font-weight: bold; margin:0">
                                {{node.label}}
                            </p>
                            <p *ngIf="node.description" style="margin-bottom:0">
                                {{node.description}}
                            </p>
                        </div>
                        <div style="white-space: nowrap;">
                            <span>({{node.childCount}})</span>
                        </div>
                    </div>
                </mat-card-content>
                <mat-card-actions *ngIf="currentUser.isPresenter" fxFlex="noshrink">
                    <button mat-button mat-icon-button (click)="editNode($event, node.id)" matTooltip="Edit" color="primary">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-button mat-icon-button (click)="deleteNode($event, node.id)" matTooltip="Delete" color="warn">
                        <mat-icon>delete</mat-icon>
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</ng-template>

<ng-template #moduleCard let-module="module">
    <div fxFlex class="module-card">
        <mat-card style="cursor: pointer;" [ngClass]="{'completed': module.completed}" (click)="playModule(module.id)" fxLayout="column" fxFlex>
            <mat-card-content fxFlex="grow" fxLayout="column">
                <div style="height:200px;background-position: center; background-size: cover;" [style.backgroundImage]="'url(' + module.image + ')'" *ngIf="module.image" fxFlex="noshrink">
                </div>
                <div style="margin: 16px; margin-bottom: 0;" fxLayout="row" fxLayoutAlign="start center" fxFlex="grow">
                    <div fxFlex="grow">
                        <p style="font-weight: bold; margin:0">
                            {{module.label}}
                        </p>
                        <p *ngIf="module.description" style="margin-bottom:0">
                            {{module.description}}
                        </p>
                    </div>
                    <div *ngIf="module.completed" fxFlex="noshrink">
                        <mat-icon color="accent" matTooltip="Completed">check_circle</mat-icon>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions *ngIf="currentUser.isPresenter" fxFlex="noshrink">
                <!-- <button mat-button mat-icon-button (click)="playModule(module.id)" matTooltip="Preview" color="primary">
                    <mat-icon>preview</mat-icon>
                </button> -->
                <button mat-button mat-icon-button (click)="editModule(module.id)" color="primary">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-button mat-icon-button (click)="deleteModule(module.id)" color="warn">
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</ng-template>